/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaTipoRegimenVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaTipoRegimen: React.FunctionComponent<ITablaTipoRegimenVistaProps & InjectedIntlProps> = ({
    tipoRegimens,
    cargarTipoRegimen,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={tipoRegimens}
            actions={acciones(manejarFormulario, cargarTipoRegimen, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaTipoRegimen);
